// extracted by mini-css-extract-plugin
module.exports = {"ReviewCard":"ReviewCard_ReviewCard__29UQD","ReviewCardRating":"ReviewCard_ReviewCardRating__1WRyW"};